<template>
    <v-container fluid>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"/>
        </v-overlay>

        <v-layout wrap>
            <v-flex xs12 md8 offset-md2 lg6 offset-lg3 xl4 offset-xl4>
                <v-card class="pa-4 align-center">
                    <v-card-text class="text-center">
                        <h1 class="mt-4 mb-12">Sign up</h1>

                        <div class="body-1">using username and password:</div>
                        <div class="mb-6">
                            <v-text-field
                                    v-model="form.username"
                                    type="text"
                                    label="Username"
                                    prepend-icon="mdi-account"
                            />
                            <v-alert type="error" v-if="typeof errors.username !== 'undefined'" dense>
                                {{ errors.username[0] }}
                            </v-alert>
                            <v-text-field
                                    v-model="form.password"
                                    type="password"
                                    label="Password"
                                    prepend-icon="mdi-lock"
                                    @keyup.enter="signUp"
                            />
                            <v-alert type="error" v-if="typeof errors.password !== 'undefined'" dense>
                                {{ errors.password[0] }}
                            </v-alert>
                        </div>
                        <v-btn class="mr-6" x-large color="primary" dark @click="signUp">Sign up</v-btn>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import AuthService from "../../services/AuthService";

  export default {
    data: () => ({
      overlay: false,
      form: {
        username: null,
        password: null
      },
      errors: {}
    }),

    methods: {
      async signUp() {
        this.overlay = true;
        this.errors = {};

        await AuthService.register(this.form)
          .then(response => {
            this.$store.dispatch("setToken", response.data.data.access_token);
            this.$store.dispatch("setUser", response.data.data.user);

            this.$router.push({name: "home"});
          })
          .catch(err => {
            this.errors = err.response.data.errors;
            this.overlay = false;
          });
      }
    }
  };
</script>
